module.exports = __webpack_public_path__ + "static/media/class.29cfbae7.svg";